import request from '@/src/apis/axios';
import {
  GetCommunityReportByIdRequestParams,
  GetCommunityReportsRequestParams,
  PutCommunityReportById,
} from '@/src/apis/rest/communityReport.dtos';

import CommunityReportDto from '@/src/models/CommunityReportDto';
import {
  CategoryResponse,
  ListResponse,
  ObjectResponse,
} from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  communityReport: '/admin/community-reports',
  communityReportDetail: '/admin/community-reports/{id}',
  communityReportExcel: '/admin/community-reports/excel/export',
  communityReportReason: '/community/community-report-reason-type',
};

// 커뮤니티 신고 리스트 조회
export const getCommunityReportsAPI = async (
  requestParams: Partial<GetCommunityReportsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<CommunityReportDto>>({
    method: 'get',
    url: URL.communityReport,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(CommunityReportDto, data.rows);

  return { rows, count: data.count };
};

// 커뮤니티 신고 상세 조회
export const getCommunityReportByIdAPI = async ({
  id,
}: GetCommunityReportByIdRequestParams) => {
  const { data } = await request<ObjectResponse<CommunityReportDto>>({
    method: 'get',
    url: URL.communityReportDetail.replace('{id}', String(id)),
  });

  const row = plainToInstance(CommunityReportDto, data.row);

  return row;
};

// 커뮤니티 신고 리스트 엑셀 다운로드
export const getCommunityReportExcelAPI = async (
  password: string,
  requestParams: Partial<GetCommunityReportsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.communityReportExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};

// 커뮤니티 신고 사유 리스트 조회
export const getCommunityReportReasonsAPI = async () => {
  const { data } = await request<ListResponse<CategoryResponse>>({
    method: 'get',
    url: URL.communityReportReason,
    queryParams: {
      isAdmin: true,
    },
  });

  return data.rows;
};

// 커뮤니티 신고 수정
export const putCommunityReport = async (
  requestBody: PutCommunityReportById,
) => {
  const { id, ...body } = requestBody;

  const { data } = await request<ObjectResponse<CommunityReportDto>>({
    method: 'put',
    url: URL.communityReportDetail.replace('{id}', String(id)),
    requestBody: body,
  });

  return data.row;
};
